import { useGridApiRef } from '@mui/x-data-grid-pro';
import type { GridApiPro } from '@mui/x-data-grid-pro';
import type { GridApiCommunity } from '@mui/x-data-grid/internals';
import type { MutableRefObject } from 'react';
import { useMonthlyClosureReport } from '../../../../hooks/requests/use-monthly-closure-report';
import { useSearchWithSearchParams } from '../../../../hooks/use-search-with-search-params';
import { ReportHeader } from '../../reports-components/ReportHeader';
import { ReportTable } from '../../reports-components/ReportTable';
import { REPORT_TYPES } from '../../reports-page/reports-page-types/report-type';
import { MonthlyClosureReportTable } from './monthly-closure-report-page-table/MonthlyClosureReportTable';

type MonthlyClosureReportContentProps = {
  reportId?: string;
};

export const MonthlyClosureReportContent: React.FC<MonthlyClosureReportContentProps> = ({ reportId }) => {
  const { data: monthlyClosureReportData, isLoading } = useMonthlyClosureReport(reportId);
  const [searchText, setSearchText] = useSearchWithSearchParams();
  const { report, startDate, endDate, creationDate } = monthlyClosureReportData;
  const apiRef = useGridApiRef();

  return (
    <>
      <ReportHeader reportData={report} startDate={startDate} endDate={endDate} creationDate={creationDate} />
      <ReportTable
        title="Monthly Closure Report"
        placeholder="Enter customer name..."
        exportCsvFileName="Monthly closure report"
        reportCreationDate={creationDate}
        onSearch={(searchValue) => setSearchText(searchValue)}
        reportType={REPORT_TYPES.MONTHLY_CLOSURE}
        apiRef={apiRef as MutableRefObject<GridApiCommunity>}
      >
        <MonthlyClosureReportTable
          isLoading={isLoading}
          filter={searchText ?? undefined}
          apiRef={apiRef as MutableRefObject<GridApiPro>}
          rows={report}
        />
      </ReportTable>
    </>
  );
};
